// extracted by mini-css-extract-plugin
export var errorsContainer = "_va-1";
export var link = "_va-0";